/* eslint-disable global-require */
import PROFILE_LIST from "@/profiles/profileList.js";
import { urlsApis, urlsApisPortal } from "@/profiles/urlsApis.js";
import profileDev from "./profile-dev.js"

function getProfile() {
	const profile = String(import.meta.env.VITE_PROFILE)
	if (profile.includes("prod")) {
		return PROFILE_LIST.PROD;
	}
	switch (profile) {
		case "hmg":
			return PROFILE_LIST.HMG;
		case "dev":
			return PROFILE_LIST.DEV;
		default:
			return PROFILE_LIST.HMG;
	}
}

export const PROFILE = getProfile();

function getConfig() {
	if (PROFILE == PROFILE_LIST.DEV) {
		return profileDev;
	}

	const config = {
		profile: PROFILE,
		apis: {
			urls: {
				BASE_URL: import.meta.env.VITE_BASE_URL,
				BASE_URL_PORTAL: import.meta.env.VITE_BASE_URL_PORTAL,
				URL_LOGOUT: import.meta.env.VITE_URL_LOGOUT,
			},
		},
	};

	// Atribuir as urls para cada api antes de exportar
	Object.entries(urlsApisPortal).forEach(([chave, valor]) => {
		config.apis.urls[chave] = config.apis.urls.BASE_URL_PORTAL.concat(valor);
	});
	// Atribuir as urls para cada api antes de exportar
	Object.entries(urlsApis).forEach(([chave, valor]) => {
		config.apis.urls[chave] = config.apis.urls.BASE_URL.concat(valor);
	});

	return config;
}

// eslint-disable-next-line import/no-dynamic-require
export const config = getConfig();
